import { filterGoalsBySearchText } from '@griply/utils';
import { useGoals } from 'features/goals';
import { useMemo } from 'react';

export const useTextFilteredGoals = (searchText: string) => {
  const goals = useGoals();

  return useMemo(
    () => filterGoalsBySearchText(goals, searchText),
    [searchText, goals],
  );
};
